import { useTranslation } from 'react-i18next'
import i18nAnalytics from '../../locales/i18n'

export const useAnalyticsTranslations = (namespace: string | string[]) => useTranslation(namespace, { i18n: i18nAnalytics })

